const dev = {
  testTenant: {
    title: 'Tenant System Test Page',
    domainTitle: 'Domain Information',
    domainDescription: 'Current domain resolution details',
    hostname: 'Hostname:',
    subdomain: 'Subdomain:',
    isCustomDomain: 'Is Custom Domain:',
    isLocalhost: 'Is Localhost:',
    baseDomain: 'Base Domain:',
    providerTitle: 'Provider Information',
    providerDescription: 'Resolved provider details from domain',
    providerId: 'Provider ID:',
    providerName: 'Provider Name:',
    providerSlug: 'Provider Slug:',
    providerDomain: 'Provider Domain:',
    customDomains: 'Custom Domains:',
    noProvider: 'No provider loaded',
    brandingTitle: 'Branding Information',
    brandingDescription: 'Provider theming and customization',
    primaryColor: 'Primary Color:',
    secondaryColor: 'Secondary Color:',
    theme: 'Theme:',
    logo: 'Logo:',
    noBranding: 'No branding configured',
    quickTestsTitle: 'Quick Tests',
    quickTestsDescription: 'Test different providers and functionality',
    providerLinksHeading: 'Test Different Providers:',
    refreshHeading: 'Refresh Tenant Data:',
    refreshButton: 'Refresh Provider',
  },
} as const

export default dev
